import { render, staticRenderFns } from "./ProductUnitEdit.vue?vue&type=template&id=5589d5a9&scoped=true&"
import script from "./ProductUnitEdit.vue?vue&type=script&lang=js&"
export * from "./ProductUnitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5589d5a9",
  null
  
)

export default component.exports